import { HttpClient } from "@angular/common/http";
import { Component, Inject, EventEmitter, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { CountryBackendEntity } from "../../../interfaces/countrybackendentity";
import { DefaultValuesService } from "../../../services/defaultvalues.service";
import { DialogService } from '../../../services/dialog.service';
import { SaveService } from '../../../services/save.service';
import { Utils } from '../../../utils/utils';
import { AzDataFactoryFormComponent } from "../azdatafactory/azdatafactoryform/azdatafactoryform.component";
import { AzDataFactoryListComponent } from "../azdatafactory/azdatafactorylist/azdatafactorylist.component";
import { CdpWikiListComponent } from "../cdpwiki/cdpwiki-list.component";

@Component({
    selector: 'service-ticket-menu',
    templateUrl: './service-ticket-menu.component.html',
    styleUrls: ['../../../style/menu.component.less'],
    standalone: false
})

export class ServiceTicketMenuComponent {

    @Output() outputDownload = new EventEmitter<{}>();
    @Output() onReload = new EventEmitter<{}>();

    constructor(private http: HttpClient
        , private activatedRoute: ActivatedRoute
        , private router: Router
        , @Inject('BASE_URL') private baseUrl: string
        , private dialogForm: MatDialog
        , public saveService: SaveService
        , private dialog: DialogService
        , public defaults: DefaultValuesService
    ) {
    }

    onUpload() {
        this.router.navigate(["file/" + Utils.getFileUploadServiceTickets()]);
    }

    openAzureDataFactoryTriggerModal(isCustomerPortal: boolean) {
        const dialogRef = this.dialogForm.open(AzDataFactoryFormComponent, {
            panelClass: 'custom-mat-dialog',
            disableClose: true,
            data: { "isCustomerPortal": isCustomerPortal, "type": "ServiceTicket", "entity": isCustomerPortal ? "Customer Portal" : "InfoHub" }
        });
    }

    showLastServiceTicketPipelineRuns() {
        const end = new Date();
        const start = new Date(new Date().setDate(end.getDate() - 30));
        Utils.httpGetLastPipelineRunsAzdf(
            this.http,
            this.baseUrl,
            'InfoHub',
            'ServiceTicket',
            start,
            end,
            this,
            function (tthis: any, list: AzDataFactoryRun[]) {
                tthis.dialogForm.open(AzDataFactoryListComponent, {
                    panelClass: 'custom-mat-dialog',
                    disableClose: true,
                    data: { "type": "ServiceTicket", "list": list, "entity": "InfoHub" }

                })
            },
            (tthis: ServiceTicketMenuComponent, error: any) => {
                if (error.status === 400 && error.error?.code === 'DATAFACTORY_NOT_CONFIGURED') {
                    tthis.dialog.showErrorStringDialog(error.error.message);
                } else {
                    tthis.dialog.showErrorDialog(error);
                }
            })
    }
    openDocumentationModal() {
        this.dialogForm.open(CdpWikiListComponent, {
            panelClass: 'custom-mat-dialog',
            data: { "entity": CountryBackendEntity.ServiceTicket }
        });
    }
}
